import React from 'react';

export const VenetianValanceTrue = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.8 63.1" {...props}>
      <path fill="#fff" d="M6.279 1.834h85.7v60.7h-85.7z" />
      <path
        d="M91.979 63.034h-85.7c-.3 0-.6-.3-.6-.6v-60.7c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c-.1.4-.3.6-.6.6zm-85.2-1.1h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M6.279 1.834h85.7v60.7h-85.7z" />
      <path
        d="M91.979 63.034h-85.7c-.3 0-.6-.3-.6-.6v-60.7c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c-.1.4-.3.6-.6.6zm-85.2-1.1h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M10.279 5.834h77.7v52.7h-77.7z" />
        <path d="M87.979 59.034h-77.7c-.3 0-.6-.3-.6-.6v-52.7c0-.3.3-.6.6-.6h77.7c.3 0 .6.3.6.6v52.7c-.1.4-.3.6-.6.6zm-77.2-1.1h76.6v-51.5h-76.6v51.5z" />
      </g>
      <path
        d="M96.279 63.034h-94.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h94.4c.3 0 .5.2.5.5s-.2.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path d="M3.7 35.5h89.2l2.9 5.2H.8l2.9-5.2z" fill="#929497" />
        <path
          d="M96.5 41.1H0L3.4 35h89.7l3.4 6.1zm-94.9-.9h93.3L92.6 36H4l-2.4 4.2z"
          fill="#fff"
        />
        <path d="M3.7 31.6h89.2l2.9 5.2H.8l2.9-5.2z" fill="#929497" />
        <path
          d="M96.5 37.3H0l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H4l-2.4 4.2z"
          fill="#fff"
        />
        <path d="M3.7 27.7h89.2l2.9 5.2H.8l2.9-5.2z" fill="#929497" />
        <path
          d="M96.5 33.4H0l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H4l-2.4 4.2z"
          fill="#fff"
        />
        <path d="M3.7 23.9h89.2l2.9 5.2H.8l2.9-5.2z" fill="#929497" />
        <path
          d="M96.5 29.5H0l3.4-6.2h89.7l3.4 6.2zm-94.9-.9h93.3l-2.3-4.2H4l-2.4 4.2z"
          fill="#fff"
        />
        <path d="M3.7 20h89.2l2.9 5.2H.8L3.7 20z" fill="#929497" />
        <path
          d="M96.5 25.7H0l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H4l-2.4 4.2z"
          fill="#fff"
        />
        <g>
          <path d="M3.7 16.2h89.2l2.9 5.2H.8l2.9-5.2z" fill="#929497" />
          <path
            d="M96.5 21.8H0l3.4-6.2h89.7l3.4 6.2zm-94.9-.9h93.3l-2.3-4.2H4l-2.4 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M3.7 12.3h89.2l2.9 5.2H.8l2.9-5.2z" fill="#929497" />
          <path
            d="M96.5 18H0l3.4-6.2h89.7l3.4 6.2zM1.6 17h93.3l-2.3-4.2H4L1.6 17z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M3.7 8.4h89.2l2.9 5.2H.8l2.9-5.2z" fill="#929497" />
          <path
            d="M96.5 14.1H0L3.4 8h89.7l3.4 6.1zm-94.9-1h93.3l-2.3-4.2H4l-2.4 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M3.7 4.6h89.2l2.9 5.2H.8l2.9-5.2z" fill="#929497" />
          <path
            d="M96.5 10.3H0l3.4-6.2h89.7l3.4 6.2zm-94.9-1h93.3l-2.3-4.2H4L1.6 9.3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M.8.5h94.9v9.7H.8z" />
          <path
            d="M96.1 10.3H.4V0h95.7v10.3zM1.2 9.2h94.1V1.1H1.2v8.1z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
